import { render, staticRenderFns } from "./administrativo.vue?vue&type=template&id=52bfc33f&scoped=true&"
import script from "./administrativo.vue?vue&type=script&lang=js&"
export * from "./administrativo.vue?vue&type=script&lang=js&"
import style0 from "./administrativo.vue?vue&type=style&index=0&id=52bfc33f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52bfc33f",
  null
  
)

export default component.exports